import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_18: FaireProductEntity = {
  token: "caden-lane-18",
  type: "product",
  name: "CuddleLane™ Luxe Waffle Blankets | Solids",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/306c518dca0334575e0d263e22553f219875fc3c3a6692a0f4db2f99b305a004.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 26,
  msrpDollars: 52,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
